// @flow

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "title", "compactTitle", "description", "mid", "button", "alert", "image", "imageContainer", "url", "cta", "icons" ]

  fetch_mid(e: Event): void {
    e.preventDefault();
    this.setButton("Laden", false);
    this.setAlert("");
    const mid = this.midTarget.value;
    fetch(`/api/admin/poms/${mid}.json`)
      .then(response => {
        if (response.ok) { return response.json() }
        throw Error(response.status.toString());
      })
      .then(response => {
        this.titleTarget.value = response.title;
        this.compactTitleTarget.value = response.title;
        this.descriptionTarget.value = response.description;
        if (this.urlTarget.value.length < 1 && response.url) {
          this.urlTarget.value = response.url;
        }
        this.setImage(response.image);
        this.setCTA();
      })
      .catch(error => {
        console.log(error);
        if (error.message === "404") { this.setAlert("Deze Mid is niet gevonden"); }
        else { this.setAlert("We hebben POMS niet kunnen bereiken"); }
      })
      .finally(() => {
        this.setButton("Importeren");
      })
  }

  setButton(text: string, enabled: boolean = true): void {
    const button = this.buttonTarget;
    enabled ? button.classList.remove("disabled") : button.classList.add("disabled");
    button.text = text;
  }

  setAlert(text: string): void {
    const alert = this.alertTarget;
    text.length > 0 ? alert.classList.remove("hidden") : alert.classList.add("hidden");
    alert.textContent = text;
  }

  setImage(imageUrl: string): void {
    const image = this.imageTarget;
    const container = this.imageContainerTarget;
    imageUrl.length > 0 ? container.classList.remove("hidden") : container.classList.add("hidden");
    image.src = imageUrl;
  }

  setCTA(): void {
    const cta = this.ctaTarget;
    if (cta.value.length === 0) {
      cta.value = "Kijk nu";
    }
    const icons = this.iconsTargets;
    const checked = icons.find(function(icon) {
      return icon.checked;
    });
    if (!checked) {
      icons.find(function(icon) {
        return icon.value === "video";
      }).checked = true;
    }
  }
}
